(function($) {
	'use strict';

	function initializeBlock(blockEl, blockClass) {
		var self = {
			blockEl: blockEl,
		};

		self.swiperSlideEls = self.blockEl.find('.swiper-slide');

		self.swiperConfig = {
			a11y: window.debAcifer.swiperA11y(),
			loop: false,
			pagination: {
				bulletActiveClass: 'bg-primary border-primary',
				bulletClass: 'w-6 h-6 border border-black block rounded mx-1',
				clickable: true,
				el: '.swiper-pagination',
				lockClass: 'hidden',
			},
			slidesPerView: 1,
			spaceBetween: 32,
			speed: 500,
			watchOverflow: true,
			watchSlidesVisibility: true,
		};

		if (2 <= self.swiperSlideEls.length) {
			self.swiperConfig.breakpoints = {};

			self.swiperConfig.breakpoints[576] = {
				slidesPerView: 2,
				spaceBetween: 32,
			};
		}

		if (3 <= self.swiperSlideEls.length) {
			self.swiperConfig.breakpoints[1024] = {
				slidesPerView: 3,
				spaceBetween: 72,
			};
		}

		if (4 <= self.swiperSlideEls.length) {
			self.swiperConfig.breakpoints[1280] = {
				slidesPerView: 4,
				spaceBetween: 32,
			};

			self.swiperConfig.breakpoints[1536] = {
				slidesPerView: 4,
				spaceBetween: 72,
			};
		}

		var swiper = new Swiper(self.blockEl.find('.swiper-container').get(0), self.swiperConfig);

		window.debAcifer.bindSwiperAriaHidden(swiper);
	}

	$(document).ready(function() {
		$('.deac-block-column-content-slider').each(function() {
			initializeBlock($(this));
		});
	});

	if (window.acf) {
		window.acf.addAction('render_block_preview/type=deac-column-content-slider', function(blockEl) {
			initializeBlock(blockEl.find('.deac-block-column-content-slider'));
		});
	}
})(jQuery);
